import { RotateCcw, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const BUCKETS = [
  { key: "awaiting_approval", label: "Așteaptă aprobare", accent: "bg-amber-500/10 text-amber-700" },
  { key: "awaiting_pickup",   label: "Așteaptă ridicare", accent: "bg-sky-500/10 text-sky-700" },
  { key: "in_transit",        label: "În tranzit",        accent: "bg-violet-500/10 text-violet-700" },
  { key: "received",          label: "Recepționate",      accent: "bg-emerald-500/10 text-emerald-700" },
  { key: "refunded",          label: "Rambursate",        accent: "bg-zinc-100 text-zinc-700" },
  { key: "rejected",          label: "Respinse",          accent: "bg-rose-500/10 text-rose-700" },
];

export default function ReturnsCard({ data }) {
  if (!data) return null;
  const buckets = data.buckets || {};
  const total = data.total || 0;
  return (
    <div className="rounded-xl border border-border bg-white p-5" data-testid="returns-card">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <RotateCcw className="h-4 w-4 text-primary" />
          <h3 className="font-display font-semibold text-base">Retururi — pipeline</h3>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-[11px] text-muted-foreground">Total: <span className="font-semibold text-foreground tabular-nums">{total}</span></span>
          <Link to="/retururi" className="text-xs text-primary hover:underline inline-flex items-center gap-0.5">
            Pipeline complet <ArrowUpRight className="h-3 w-3" />
          </Link>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {BUCKETS.map((b) => (
          <div key={b.key} className={`rounded-lg px-3 py-3 ${b.accent}`} data-testid={`returns-bucket-${b.key}`}>
            <div className="text-[10px] uppercase tracking-widest font-semibold opacity-80">{b.label}</div>
            <div className="font-display text-2xl font-bold mt-1 tabular-nums">{buckets[b.key] || 0}</div>
          </div>
        ))}
      </div>
      <div className="mt-5 border-t border-border pt-4">
        <div className="text-[10px] uppercase tracking-widest font-semibold text-muted-foreground mb-2">Distribuție pe statusuri</div>
        <div className="space-y-1.5 max-h-44 overflow-y-auto">
          {(data.by_status || []).filter(r => r.count > 0).map((row) => (
            <div key={row.status.id} className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2 min-w-0">
                <span className="h-2 w-2 rounded-full shrink-0" style={{ background: row.status.color || "#71717a" }} />
                <span className="truncate">{row.status.name}</span>
              </div>
              <span className="font-mono text-xs tabular-nums text-muted-foreground">{row.count}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
